module.exports = __webpack_public_path__ + "img/2.cdd1acf1.png";